<script>
    import Spinner from "../../spinner/Spinner.svelte";
    import FormErrors from "../../forms/FormErrors.svelte";
    import {apiFetch, apiPost} from '../../../apiFetch';
    import {createForm, Field} from "svelte-forms-lib";
    import {
        Button,
        Form,
        FormGroup,
        Input,
        Label,
    } from 'sveltestrap';
    import {goto} from "@sveltech/routify/runtime";
    import {_} from 'svelte-i18n';

    let submitting = false;
    let formError = null;
    export let event;
    export let completed;
    export let id;

    const eventText = event.event_text.find((eventText) => eventText.id === id);

    const {form, handleChange, handleSubmit} = createForm({
        initialValues: {
            description: eventText.description ? eventText.description : '',
        },
        onSubmit: values => {
            submitting = true;
            // nested a sub object (so form name = event_text AND sub entity = event_text)
            const postData = {
                event_text: {
                    event_text: {
                        ...values,
                        id: eventText.id
                    }
                }
            };
            apiPost('/events/' + event.id, postData)
                    .then((result) => {
                        if (result.status !== 200) {
                            formError = result.errors;
                        } else {
                            completed();
                        }
                        submitting = false;
                    })
                    .catch((error) => {
                        alert(error);
                        submitting = false;
                    });
        }
    });

</script>

{#await apiFetch('/organizations')}
    <Spinner/>
{:then data}
    {#if submitting}
        <Spinner/>
    {/if}
    {#if formError}
        <FormErrors errors={formError}/>
    {/if}
    <Form on:submit={handleSubmit} class="content">
        <FormGroup>
            <Label for="description">Description</Label>
            <Input
                    id="description"
                    name="description"
                    type="textarea"
                    on:change={handleChange}
                    bind:value={$form.description}
                    rows="15"
            />
        </FormGroup>

        <FormGroup>
            <Button type="submit" color="primary">{$_('global.save')}</Button>
        </FormGroup>

    </Form>
{:catch error}
    {@debug error}
    <p>An error occurred!</p>
{/await}